import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { AccTeamDialogDataService } from './acc-team-dialog-data.service';
import { AccTeamDetailsPart } from './details/details.part';
import { AccTeamMentorsPart } from './mentors/mentors.part';
import { AccTeamOverlappingMeetingsPart } from './overlapping-meetings/overlapping-meetings.part';
import { AccTeamVenturesPart } from './ventures/ventures.part';

@Component({
	selector: 'acc-team-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		TabStripModule,
		AccTeamDetailsPart,
		AccTeamMentorsPart,
		AccTeamVenturesPart,
		AccTeamOverlappingMeetingsPart
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-team.dialog.html'
})

export class AccTeamDialog implements OnInit {

	public dialogRef = inject(MatDialogRef<AccTeamDialog>);
	public dialogContext: DialogContext<{ accTeamId: number }> = inject(MAT_DIALOG_DATA);
	public readonly dialogDataService = inject(AccTeamDialogDataService);


	async ngOnInit() {
		const data = this.dialogContext.data;
		if (data) {
			await this.dialogDataService.loadData(data.accTeamId);
		}
	}

	public readonly headerName = computed(() => {
		const data = this.dialogDataService.dialogData();
		if (!data) return 'Team';
		return `Team: ${data.name}`
	});

	public actions: DialogAction[] = [
		{
			id: 'close',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Close'),
			linkType: "no-action",
			willCloseDialog: true,
		}
	];

}